import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,TabbedForm,FormTab,Create
 }
from 'admin-on-rest/lib/mui';

export const BankList = (props) => (
    <List title="רשימת בנקים" {...props}>
        <Datagrid>
            <TextField label="#" source="id" />
             <TextField label="קוד בנק" source="code" />
             <TextField  label="בנק" source="bank" />
   <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

const BankTitle = ({ record }) => {
    return <span>Bank {record ? `"${record.bank}"` : ''}</span>;
};


export const BankShow = (props) => (

<Show title={<BankTitle />} {...props}>
 <SimpleShowLayout>
        <TextField label="#" source="id" />
        <TextField label="קוד בנק" source="code" />
        <TextField label="בנק" source="bank" />

         </SimpleShowLayout>
    </Show>
);


export const BankEdit = (props) => (
    <Edit {...props}>

        <SimpleForm>
 <DisabledInput source="id" />
<TextInput  source="code" />
<TextInput  source="bank" />
        </SimpleForm>
  </Edit>
);

export const BankCreate = (props) => (
    <Create title="הוספת בנק חדש" {...props}>
      <TabbedForm >
          <FormTab label="בנק">
              <DisabledInput label="Id" source="id" />
                <TextInput source="code" label="קוד בנק"/>
                <TextInput source="bank" label="בנק" />

          </FormTab>



      </TabbedForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/components/Banks/banks.js